import { ChapterHeader, FadeUp } from "./Motion";
import { Target, MapPinned, Building2, Sparkles, GraduationCap, Compass } from "lucide-react";

export default function CollegeFit({ content }) {
    const cf = content.collegeFit || {};
    const items = [
        { icon: Target, label: "Divisions", value: (cf.divisions || []).join(" · ") },
        { icon: GraduationCap, label: "Academic Interests", value: cf.academicInterests },
        { icon: MapPinned, label: "Geographic Preference", value: cf.geographic },
        { icon: Building2, label: "Campus Size", value: cf.campusSize },
        { icon: Sparkles, label: "Wrestling Culture", value: cf.wrestlingCulture },
        { icon: Compass, label: "Career Goal", value: cf.careerGoals },
    ];
    return (
        <section id="college-fit" className="relative py-20 md:py-32 border-t border-white/10">
            <div className="absolute right-0 top-0 w-[500px] h-[500px] radial-gold opacity-40 pointer-events-none" />
            <div className="max-w-[1600px] mx-auto px-5 md:px-10 relative z-10">
                <ChapterHeader
                    num="08"
                    kicker="Fit Assessment"
                    title="What I'm Looking For"
                    testId="chapter-fit"
                />

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
                    {items.map(({ icon: Icon, label, value }, i) => (
                        <FadeUp key={label} delay={i * 0.05}>
                            <div className="p-6 md:p-8 bg-black h-full">
                                <div className="flex items-center gap-2 chapter-num">
                                    <Icon size={12} /> {label}
                                </div>
                                <div className="editorial text-xl md:text-2xl mt-4 text-white/90 leading-snug">
                                    {value}
                                </div>
                            </div>
                        </FadeUp>
                    ))}
                </div>
            </div>
        </section>
    );
}
